import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';

import { BirthdayTagColor } from './types';

@Component({
  selector: 'birthdays-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagComponent {
  private readonly translateService = inject(TranslateService);

  @Input() set value(date: Date | string) {
    this.text = formatDate(date, 'dd MMMM', this.translateService.currentLang);

    const currentDate = new Date();
    const dateNormalize = new Date(date);
    if (dateNormalize.getDate() === currentDate.getDate() && dateNormalize.getMonth() === currentDate.getMonth()) {
      this.color = 'yellow';
    } else {
      this.color = 'grey';
    }
  }

  text?: string;
  color?: BirthdayTagColor;
}
